import React from 'react';

import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { tabs } from './BottomNavBar.const';
import { getTabFromPath } from './BottomNavBar.utils';

const BottomNavBar: React.FC = () => {
  const location = useLocation();
  const [selectedTab, selectTab] = React.useState<string>(getTabFromPath(location.pathname));

  return (
    <BottomNavigation
      value={selectedTab}
      onChange={(_, newValue) => {
        selectTab(newValue);
      }}
      showLabels
    >
      {tabs.map(({ label, Icon, path, Component }) => (
        <BottomNavigationAction
          key={label}
          label={<FormattedMessage id={label} />}
          icon={<Icon />}
          component={Component}
          to={path}
          value={path}
        />
      ))}
    </BottomNavigation>
  );
};

export default BottomNavBar;
